<div class="login-main-wrapper min-image-handel m-0 align-items-center p-4">
    <!-- <div class="">
            <app-left-layout></app-left-layout>
        </div> -->
    <div class="left-side">
        <div class="logo ">
            <img src="assets/images/img/logo-main.png" alt="logo">
        </div>
        <div class="inner-wrapper min-image-handel-card">
            <div class="right-content p-3 p-lg-0">
                <!-- <app-google-translate></app-google-translate> -->
                <h2 class="fs-32 fw-600 m-0 main-heading" *ngIf="selectedStep === step.REGISTER">
                    We Help Businesses Collect Outstanding Debt
                </h2>
                <div class="d-flex align-items-center login-signup-toggle gap-4"
                    [class.d-none]="selectedStep === step.VERIFY_OTP">
                    <button class="fs-16 fw-400 m-0 text-center" [routerLink]="'/login'"
                        routerLinkActive="router-link-active">
                        Sign In
                    </button>
                    <button class="fs-16 fw-400 m-0 text-center" [routerLink]="'/register'"
                        routerLinkActive="router-link-active">
                        Sign Up
                    </button>
                </div>
                <div class="mb-0" *ngIf="selectedStep === step.REGISTER">
                    <p class="fs-16 fw-400 text-secondary m-0">
                        Please enter your details to begin your journey
                    </p>
                </div>

                <div class="" *ngIf="selectedStep == step.REGISTER">
                    <form class="h-100 example-form" (submit)="submitForm()">
                        <div class=" pb-0 h-100 flex-wrap register-business-div">

                            <ng-container [formGroup]="signUpForm">
                                <div class=" form-group pr-md-0 mt-3">
                                    <div class="input-relative"
                                        [ngClass]="[ signUpForm && (signUpForm['controls']['doctor_email'].touched && signUpForm['controls']['doctor_email'].invalid || (signUpForm['controls']['doctor_email'] && signUpForm['controls']['doctor_email']['errors'])) ? 'custom-form inputContainer' : 'custom-form ']">

                                        <input type="text" class="w-100" required name="doctor_email" maxlength="50"
                                            trim="true" formControlName="doctor_email" autocomplete="off"
                                            [attr.autocomplete]="'new-email-' + randomString"
                                            [attr.readonly]="signUpForm.controls['doctor_email'].value ? null : ''"
                                            (focus)="removeReadonly($event)" />
                                        <label for="text" class="label-name fs-14 w-100">
                                            Email address
                                        </label>
                                    </div>
                                    <p class="mat-error mb-0 ml-0 pl-0 fs-14 text-danger"
                                        *ngIf=" ((signUpForm['controls']['doctor_email'].touched ) && signUpForm['controls']['doctor_email'].invalid)">
                                        Enter a valid email (a-z, 0-9, &#64; only)
                                    </p>
                                </div>
                                <div class="mt-1">
                                    <p class="mat-error text-danger w-100 d-block fs-14" *ngIf="signUpForm.hasError('credentialsMismatch')">
                                        {{this.errorotp}}
                                    </p>
                                </div>

                                <div class=" form-group pr-md-0 mt-3">
                                    <!-- <div class="input-relative" >
                                            <input [type]="!hidePwd ? 'password' : 'text'" class=" w-100"
                                            
                                                name="password" formControlName="doctor_password" autocomplete="off" />
                                            <label for="text" class="label-name fs-14 w-100">
                                                Create password
                                            </label>
                                            <img [src]="hidePwd ? 'assets/images/icons/open-eye.svg' : 'assets/images/icons/close-eye.svg'"
                                                alt="" class="position-absolute eye-icon cursor"
                                                (click)="hidePwd = !hidePwd">
                                        </div> -->
                                    <div class="position-relative">
                                        <div class="input-relative position-relative">
                                            <input [type]="!hidePwd ? 'password':'text'" class=" w-100" name="password"
                                                autocomplete="off" required formControlName="doctor_password"
                                                (focus)="showPassTooltip = true" (blur)="showPassTooltip = false" />
                                            <label for="text" class="label-name fs-14 w-100">
                                                Create password
                                            </label>
                                            <img [src]="hidePwd ? 'assets/images/icons/open-eye.svg' : 'assets/images/icons/close-eye.svg'"
                                                alt="" class="position-absolute eye-icon cursor"
                                                (click)="hidePwd = !hidePwd">
                                        </div>
                                        <span style="
                                        width: 60%;
                                        box-shadow: 3px 3px 11px #000;
                                    " class="position-absolute d-block bg-white px-3 py-3 mnw-300 info-tooltip border-tooltip radius-16"
                                            *ngIf="showPassTooltip">
                                            <p style="padding: 0 0 0 12px !important;margin-bottom: 0px; font-size: 16px;"
                                            class="m-0 fs-12 fw-800 fs-12 m-0 p-0">
                                            <!-- {{!passwordStrength || passwordStrength === 'Empty'? 'Password Strength Indication' : passwordStrength}} -->
                                            Password must contain
                                        </p>
                                            <div class="d-flex align-items-center justify-content-between my-2"
                                                style="padding-left: 10px;">
                                                <!-- <ng-container *ngFor="let item of [].constructor(4); let i = index">
                                                    <span class="w-52 mx-1"
                                                        [ngClass]="((i < totalStrength) && ((totalStrength === 1)) ? 'border-orange' : (((i < totalStrength) && (totalStrength === 2))? 'border-orange' : (((i < totalStrength) && (totalStrength === 3))? 'border-green' : (((i < totalStrength) && (totalStrength === 4))? 'border-green' : 'border-top'))))">
                                                    </span>
                                                </ng-container> -->
                                            </div>
                                            <ul class="tooltip-list" style="text-align: left;font-size: 14px;">
                                                <p class="fs-14 color-22 m-0 pb-1">It’s better to have:</p>
                                                <li style="display: flex;align-items: center;"
                                                    [ngClass]="{'text-decoration-line-through color-167': hasMaxChar}"
                                                    class="text-nowrap text-decoration-none fs-14 color-22 mt-1"><span
                                                        style="display: flex;justify-content: center;align-items: center;"
                                                        class=" hw-16"
                                                        [ngClass]="{'p-1 bg-blue-206': hasMaxChar}"><img
                                                            [src]="hasMaxChar ? 'assets/images/icons/tick-blue.png' : 'assets/images/icons/blue-circle.png'"
                                                            alt=""></span>Atleast 8 characters </li>
                                                <li style="display: flex;align-items: center;"
                                                    [ngClass]="{'text-decoration-line-through color-167': hasUpperCase}"
                                                    class="text-nowrap text-decoration-none fs-14 color-22 mt-1"><span
                                                        style="display: flex;justify-content: center;align-items: center;"
                                                        class=" hw-16"
                                                        [ngClass]="{'p-1 bg-blue-206': hasUpperCase}"><img
                                                            [src]="hasUpperCase ? 'assets/images/icons/tick-blue.png' : 'assets/images/icons/blue-circle.png'"
                                                            alt=""></span>Mix upper & lowercase letters</li>
                                                <li style="display: flex;align-items: center;"
                                                [ngClass]="{'text-decoration-line-through color-167': hasSpecialChar}"
                                                    class="text-nowrap text-decoration-none fs-14 color-22 mt-1"><span
                                                        style="display: flex;justify-content: center;align-items: center;"
                                                        class=" hw-16"
                                                        [ngClass]="{'p-1 bg-blue-206': hasSpecialChar}"><img
                                                            [src]="hasSpecialChar ? 'assets/images/icons/tick-blue.png' : 'assets/images/icons/blue-circle.png'"
                                                            alt=""></span>Add a special characters (like !&#64;#$).</li>
                                                <li style="display: flex;align-items: center;"
                                                    [ngClass]="{'text-decoration-line-through color-167': hasNumber}"
                                                    class="text-nowrap text-decoration-none fs-14 color-22 mt-1"><span
                                                        style="display: flex;justify-content: center;align-items: center;"
                                                        class=" hw-16"
                                                        [ngClass]="{'p-1 bg-blue-206': hasNumber}"><img
                                                            [src]="hasNumber ? 'assets/images/icons/tick-blue.png' : 'assets/images/icons/blue-circle.png'"
                                                            alt=""></span>Include a number (0-9)</li>
                                                
                                            </ul>
                                        </span>
                                    </div>
                                    <p class="mat-error mb-0 ml-0 pl-0 fs-14 text-danger"
                                        *ngIf="signUpForm['controls']['doctor_password'].hasError('whitespace')">
                                        No spaces are allowed in the password.
                                    </p>
                                    <p class="mat-error mb-0 ml-0 pl-0 fs-14 text-danger"
                                        *ngIf="signUpForm['controls']['doctor_password'].touched && signUpForm['controls']['doctor_password'].invalid && !signUpForm['controls']['doctor_password'].dirty">
                                        Please enter password.
                                    </p>
                                    <p class="mat-error mb-0 ml-0 pl-0 fs-14 text-danger"
                                        *ngIf="!ispasswordStrong">
                                        Please Enter a Strong Password
                                    </p>
                                </div>
                                <div class="form-group pr-md-0 mt-3 contact-country-select">
                                    <div class="input-relative">
                                        <select name="country_code" id="country_code" class="input_field w-100 m-0"
                                            placeholder="Select Country"
                                            [ngClass]="{ 'border-danger' : ((signUpForm['controls']['country_code'].touched && signUpForm['controls']['country_code'].invalid && !signUpForm['controls']['country_code'].dirty))}"
                                            formControlName="country_code" (change)="onCountryChange($event)"
                                            [class.value-field]="((!signUpForm['controls']['country_code'].invalid))">
                                            <option [value]="''" disabled class="new-label">Select Country</option>
                                            <option *ngFor="let country of country_list" [value]="country.country_id">
                                                {{ country['country_name'] }}</option>
                                        </select>
                                        <p class="mat-error text-danger w-100 d-block mb-0 fs-14"
                                            *ngIf="((signUpForm['controls']['country_code'].touched || signUpForm['controls']['country_code'].dirty) && signUpForm['controls']['country_code'].invalid)">
                                            Country is required </p>
                                    </div>
                                </div>
                                <div class="mt-4">
                                    <button type="button" class="legal-consent w-100 d-flex align-items-center gap-3"
                                        [class.accepted]="legalAccepted" (click)="showLegalModal()">
                                        <span class="legal-consent-icon d-flex align-items-center justify-content-center">
                                            <svg *ngIf="legalAccepted" viewBox="0 0 14 14" fill="none">
                                                <path d="M2.5 7.5L5.5 10.5L11.5 3.5" stroke="currentColor"
                                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            <svg *ngIf="!legalAccepted" viewBox="0 0 18 18" fill="none">
                                                <path d="M4 2.75h6l4 4v8.5a.75.75 0 0 1-.75.75h-9.5a.75.75 0 0 1-.75-.75V3.5a.75.75 0 0 1 .75-.75Z"
                                                    stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" />
                                                <path d="M6 9.5h6M6 12h4" stroke="currentColor" stroke-width="1.4"
                                                    stroke-linecap="round" />
                                            </svg>
                                        </span>
                                        <span class="legal-consent-text fs-14">
                                            <ng-container *ngIf="!legalAccepted">Review the <strong>Terms and
                                                    Condition</strong> and <strong>Privacy Policy</strong> to
                                                continue</ng-container>
                                            <ng-container *ngIf="legalAccepted">You have accepted the <strong>Terms and
                                                    Condition</strong> and <strong>Privacy
                                                    Policy</strong></ng-container>
                                        </span>
                                    </button>
                                </div>
                            </ng-container>
                            <div class=" form-group mt-4">
                                <button button-primary-auth type="submit"
                                    [disabled]="signUpForm.invalid || !ispasswordStrong || !legalAccepted"
                                    class="btn btn-primary w-100 fs-16 fw-600 mb-3">Continue</button>
                                <!-- (click)="socialSignIn()" [class.disable]="!checkBtn"-->
                              
                                <!-- <p class="mat-error mb-0 ml-0 pl-0" *ngIf="(signUpForm['errors'])">
                                    {{signUpForm && signUpForm['errors']}}
                                </p> -->
                            </div>
                        </div>

                    </form>
                    <app-google-sign-in [country_id]="counCurData.country_id"
                    [currency_id]="counCurData.currency_id"></app-google-sign-in>

                </div>
                <!-- *ngIf="selectedStep === step.VERIFY_OTP" -->
                <ng-container *ngIf="selectedStep === step.VERIFY_OTP">
                    <div class="mb-4 otp-header">
                        <h2 class="fs-32 fw-600 m-0 mb-3">
                            We’ve emailed you a code
                        </h2>
                        <p class="fs-16 fw-400 m-0">
                            To complete your account setup, enter the code we have sent to
                            <b>{{signUpForm.controls['doctor_email'].value}}</b>
                            <!-- <a (click)="selectedStep = step.REGISTER" class="text-line cursor ms-2">Change</a>. -->
                        </p>
                    </div>

                    <div class=" form-group mt-4 mb-3">
                        <form [formGroup]="otpForm" action="" (submit)="verifyOtp()" (keydown.enter)="$event.preventDefault()">
                            <div class="form-group otp_fields new-otp_fields mb-3 mt-2 d-flex justify-content-between">
                                <input id={{item}} (input)="onInput($event , index)"
                                    (keydown.backspace)="onDelete($event , index)" [formControlName]="item" type="text"
                                    maxlength="1"
                                    autocomplete="off"
                                    *ngFor="let item of otpValueGroup; let index = index"
                                    placeholder="-"  (paste)="onPasteHandler($event.clipboardData?.getData('text/plain'))"/>
                            </div>
                            <div>
                                <p class="mat-error text-danger w-100 d-block fs-14"
                                    *ngIf="otpForm.hasError('credentialsMismatch')">
                                    {{this.errorotp}}
                                </p>
                            </div>
                            <div class="mb-3 resend-email">
                                <h4 class="fs-14 mb-2" *ngIf="countdown > 0">Request new Verification code in {{
                                    formatTime(countdown) }}
                                    seconds</h4>
                                <h4 *ngIf="countdown <= 0" class="fs-14 fw-400">Didn’t receive an otp?
                                    <span class="cursor" (click)="renewOtp()">Resend otp</span>
                                </h4>
                            </div>
                            <!-- <button class="btn btn-primary w-100 fw-500 mb-3" type="submit">Create My
                                Account</button> -->
                            <button type="button" (click)="bactoRegister();" class="fw-500 fs-18 btn btn-default w-100">
                                Back to Sign Up
                            </button>
                        </form>
                    </div>
                    <!-- <a (click)="selectedStep = step.REGISTER" class="text-line cursor">Change your email</a> -->
                </ng-container>
            </div>
        </div>
        <div class="align-items-center d-flex flex-wrap justify-content-between terms-condition-wrap gap-2">
            <div class="left">
                <p class="fs-14 fw-300 mb-0">
                    ©{{_shared.epoch}} Recuvery LLC. All rights reserved.
                </p>
            </div>
            <div class="right">
                <ul class="d-flex align-items-center gap-2 mb-0 policy--listing">
                    <li class="fs-14 fw-400">
                        <a href="{{env.websiteUrl}}privacy-policy" target="_blank">Privacy Policy</a>
                    </li>
                    <li>•</li>
                    <li class="fs-14 fw-400">
                        <a href="{{env.websiteUrl}}terms-and-conditions" target="_blank"> Terms &
                            Conditions</a>
                    </li>
                </ul>
            </div>
        </div>
        <!-- createBusinessAccount -->

    </div>
    <div class="min-image-handel-card left-card-wrapper d-none  p-0">
        <div class="login-left--wrapper">
            <div class="image-div">
                <img class="main-image" src="assets/images/img/main-image.png" alt="login register">
            </div>
            <!-- <img src="assets/images/img/backgound-main.png"> -->
            <div class="bottom-content">
                <div class="left d-flex gap-2 align-items-center">
                    <img src="assets/images/img/call-icon.png">
                    <p class="mb-0 fw-500 fs-16">Call us at <span>+1 (833) 904-7001</span></p>
                </div>
                <div class="right btn-group gap-3">
                    <a class="fw-500 fs-16 btn btn-white" href="https://www.recuvery.com/demo-scheduler/"
                        target="_blank">Book a Demo</a>
                    <button class="fw-500 fs-16 btn btn-black d-none">
                        <img src="assets/images/img/player-play-filled.png">
                        <span>Watch Video</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>